const API_URL = process.env.REACT_APP_API_URL;

export function getFullImageUrl(imageUrl) {
    if (!imageUrl) return '';
    if (imageUrl.startsWith('http')) return imageUrl;
    if (imageUrl.startsWith('/api')) {
        return `${API_URL.replace('/api', '')}${imageUrl}`;
    }
    return imageUrl;
}
